
<div class="page-results flex column" [ngClass]="ms.endpoint">
  <results-info [searchResultUpdateTime]="ss.searchResult.lastUpdated" [numFound]="ss.searchResult.numFound" [start]="ss.searchResult.start" [end]="ss.searchResult.end" [parentsInPage]="ss.searchResult.parentsInPage" [interactive]="ms.endpoint!=='explore'"></results-info>
  <div class="blueBarActions textBlock" *ngIf="countSelectedResults > 0">
    <div class="addToReport">
      <h6>{{ ('page_results.add_n_to_report' | translate).replace("{n}", countSelectedResults) }} :</h6>
      <ul>
        <li *ngFor="let name of rs.reportsNames" [class.disabled]="rs.reports.st13[name].st13s.length + countSelectedResults &gt; 180">
          <label>
            <input type="checkbox" [(ngModel)]="checkedReports[name]"><span>&nbsp;{{name}}</span>
          </label><span>&nbsp;({{rs.reports.st13[name].st13s.length}}/180 max)</span><span class="red">&nbsp;{{"page_results.report_would_be_too_big" | translate}}</span>
        </li>
        <li>
          <label class="flex center-v">
            <input type="checkbox" [(ngModel)]="checkedReports['$$new']"><span>&nbsp;{{ "page_results.new_report" | translate }} :&nbsp;</span>
            <w-input-text class="flexGrow" label="Report name" [(ngModel)]="newReportName" (keyup.enter)="addToReports()" (keyup)="checkedReports['$$new']=!!newReportName.length"></w-input-text>
          </label>
        </li>
      </ul><br>
      <div class="buttons flex flex-end">
        <button w-button size="small" [isDefault]="true" [disabled]="!checkedReportsKeys.length" label="{{ 'page_results.add_to_report' | translate }}" (click)="addToReports()"></button>
      </div>
    </div>
  </div>
  <w-validation-panel *ngIf="!ps.getPref('layout')" type="error" summary="No layout defined! (ps.getPref('layout')==={{ '' + ps.getPref('layout') }})"></w-validation-panel>
  <ng-container *ngIf="ss.searchResult.docs.length">
    <search-results-menu (menuChoiceEvent)="onMenuChoice($event)" (menuActionEvent)="onMenuAction($event)"></search-results-menu>
    <facets-search [solrFacets]="solrFacets || {}">
      <results-list-gbd *ngIf="ms.instanceType=='gbd'" [docs]="ss.searchResult.docs"></results-list-gbd>
      <results-list-gdd *ngIf="ms.instanceType=='gdd'" [docs]="ss.searchResult.docs"></results-list-gdd>
    </facets-search>
  </ng-container>
</div>
